import { useDelete } from '@refinedev/core';

export function useDeleteFamily() {
  const { mutateAsync, error, isLoading, reset } = useDelete();

  const deleteFamily = async (id: string) => {
    return mutateAsync({
      resource: 'families',
      id,
    });
  };

  return {
    deleteFamily,
    error,
    isLoading,
    reset,
  };
}
